import { registerLocaleData } from '@angular/common';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import localeSv from '@angular/common/locales/sv';
import { ApplicationConfig, importProvidersFrom, LOCALE_ID, provideZoneChangeDetection } from '@angular/core';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideRouter, withPreloading, withViewTransitions } from '@angular/router';
import { provideServiceWorker } from '@angular/service-worker';
import { environment } from '@environments/environment';
import { LOCAL_STORAGE_ENGINE, withNgxsStoragePlugin } from '@ngxs/storage-plugin';
import { provideStore } from '@ngxs/store';
import { defineLocale, svLocale } from 'ngx-bootstrap/chronos';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { ModalModule } from 'ngx-bootstrap/modal';
import { PaginationModule } from 'ngx-bootstrap/pagination';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { TimepickerModule } from 'ngx-bootstrap/timepicker';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { provideToastr } from 'ngx-toastr';
import { routes } from './app.routes';
import { SelectivePreloadingStrategy } from './core/config/selective-preloading.strategy';
import { TokenInterceptor } from './core/interceptors/token.interceptor';
import { AuthContextState } from './shared/state/auth-context/auth-context.state';
import { DomainContextState } from './shared/state/domain-context/domain-context.state';
import { UserContextState } from './shared/state/user-context/user-context.state';

registerLocaleData(localeSv, 'sv-SE');
defineLocale('sv', svLocale);

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes, withViewTransitions(), withPreloading(SelectivePreloadingStrategy)),
    provideHttpClient(withInterceptorsFromDi()),
    provideAnimations(),
    provideToastr({
      positionClass: 'toast-top-left',
      timeOut: 5000,
      preventDuplicates: true,
      closeButton: true,
      maxOpened: 5,
      tapToDismiss: true,
      progressBar: true,
      progressAnimation: 'decreasing'
    }),
    importProvidersFrom(
      TooltipModule.forRoot(), // Import TooltipModule as a provider
      BsDatepickerModule.forRoot(),
      TimepickerModule.forRoot(),
      ModalModule.forRoot(),
      TabsModule.forRoot(),
      PaginationModule.forRoot()
    ),
    provideServiceWorker('ngsw-worker.js', {
      enabled: environment.serviceWorkerEnabled,
      registrationStrategy: 'registerWhenStable:30000'
    }),
    { provide: HTTP_INTERCEPTORS, useClass: TokenInterceptor, multi: true },
    { provide: LOCALE_ID, useValue: 'sv-SE' },
    provideStore(
      [UserContextState, AuthContextState, DomainContextState],
      withNgxsStoragePlugin({
        keys: [
          { key: 'authContext', engine: LOCAL_STORAGE_ENGINE },
          { key: 'userContext', engine: LOCAL_STORAGE_ENGINE },
          { key: 'domainContext', engine: LOCAL_STORAGE_ENGINE }
        ]
      })
    ),
    // provideAppInitializer(() => { // uncomment when we are ready to use idle.service
    //   inject(IdleService);
    // }),
  ]
};
